<template>
  <div class="tree-cont">
    <div class="tree">
      <div ref="treeWrap">
        <span @click="checkAll" style="cursor: pointer">select all</span> /
        <span style="cursor: pointer" @click="checkNone">select none</span>
        <ul class="target-tree" style="height: 360px; overflow: auto">
          <RecycleScroller class="scroller" :items="localItems" :item-size="32" key-field="id" v-slot="{ item }">
            <li class="tree-item">
              <div class="item parent" :class="[{ checked: item.checked }]">
                <label class="checkbox" :class="[
                  {
                    checked: item.checked,
                    indeterminate: checkIndeterminate(item),
                  },
                ]">
                  <input type="checkbox" v-model="item.checked" @change="onCheck(item)" />
                  <span></span>
                </label>
                <div class="name">{{ item.name }}</div>
                <!-- <div class="resources" v-if="item.assets_count">
                      items: {{ item.assets_count }}
                    </div> -->
              </div>

            </li>
          </RecycleScroller>
        </ul>
        <!--
        <ul class="target-tree" style="height: 360px; overflow: auto">
          <DynamicScroller :items="localItems" :min-item-size="36" class="scroller">
            <template v-slot="{ item, index, active }">
              <DynamicScrollerItem :item="item" :active="active" :data-index="index">
                <li class="tree-item">
                  <div class="item parent" :class="[{ checked: item.checked }]">
                    <label class="checkbox" :class="[
                      {
                        checked: item.checked,
                        indeterminate: checkIndeterminate(item),
                      },
                    ]">
                      <input type="checkbox" v-model="item.checked" @change="onCheck(item)" />
                      <span></span>
                    </label>
                    <div class="name">{{ item.name }}</div>
                    <!-- <div class="resources" v-if="item.assets_count">
                      items: {{ item.assets_count }}
                    </div> 
                  </div>

                </li>
              </DynamicScrollerItem>
            </template>
          </DynamicScroller>
        </ul>
      -->
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
export default {
  name: "TargetsTree",
  props: {
    assetsOrScopes: { type: Array },
    mode: { type: String, default: "scopes" },
  },
  data() {
    return {
      localItems: [],
    };
  },
  watch: {
    assetsOrScopes: function (n, o) {
      console.log('items', n);
      this.processTargets(n);
    },
  },
  computed: {

  },
  methods: {
    onCheck(item) {
      console.log("on check", item);
      /*
      if (item.type === "scope") {
        console.log("onCheck scope");
        // this.localItems[index].checked = true;
        if ("items" in item) {
          for (var y = 0; y < item.items.length; y++) {
            //this.localItems[index].expand = true;
            item.items[y].checked = item.checked;
          }
        }
      } else {
        // item is an asset elem
        for (let index in this.localItems) {
          if (this.localItems[index].id == item.scope_id) {
            if (this.checkScopeChecked(this.localItems[index])) {
              this.localItems[index].checked = true;
            } else {
              this.localItems[index].checked = false;
            }
          }
        }
      }
      */
      if (item.checked) {
        // this.checkedAssets.add(item.title);
      } else {
        // this.checkedAssets.delete(item.title);
      }
    },
    checkAll() {
      for (let index in this.localItems) {
        this.localItems[index].checked = true;
        if ("items" in this.localItems[index]) {
          for (var y = 0; y < this.localItems[index].items.length; y++) {
            this.localItems[index].expand = true;
            this.localItems[index].items[y].checked = true;
          }
        }
      }
    },
    checkNone() {
      for (let index in this.localItems) {
        this.localItems[index].checked = false;
        if ("items" in this.localItems[index]) {
          for (var y = 0; y < this.localItems[index].items.length; y++) {
            this.localItems[index].expand = false;
            this.localItems[index].items[y].checked = false;
          }
        }
      }
    },
    checkScopeChecked(scope) {
      let total = scope.items.length;
      if (total < 1) return false;
      let checked = 0;
      for (var i = 0; i < scope.items.length; i++) {
        if (scope.items[i].checked) checked++;
      }
      console.log("checkScopeChecked", total, checked);
      return total == checked;
    },
    checkIndeterminate(scope) {
      let total = scope.length;
      if (total < 1) return false;
      let checked = 0;
      for (var i = 0; i < scope.length; i++) {
        if (scope[i].checked) checked++;
      }
      return checked > 0 && total != checked;
    },
    getCheckedValues() {
      let ids = [];
      // let v = Array.from(this.checkedAssets);
      for (let item of this.localItems) {
        if (item.checked) {
          ids.push(item.id);
        }
      }
      return ids; // _.uniq(v);
    },
    processTargets(items) {
      console.log('processTargets', items);
      // console.log("got items", items);
      let that = this;
      /*
      for (let checkedItem of this.checkedAssets.values()) {
        if (!this.treeHas(items, checkedItem)) {
          items.unshift({ checked: true, title: checkedItem });
        } else {
          // console.log("there is ", checkedItem);
        }
      }
     
      // check top level values
      for (var i = 0; i < items.length; i++) {
        if (that.checkedAssets.has(items[i].title)) {
          items[i].checked = true;
        }
        if ("items" in items[i]) {
          for (var y = 0; y < items[i].items.length; y++) {
            if (that.checkedAssets.has(items[i].items[y].hash)) {
              items[i].expand = true;
              items[i].items[y].checked = true;
            }
          }
        }
      }
       */
      this.localItems = items;
    },
    treeHas(items, title) {
      for (var i = 0; i < items.length; i++) {
        if (items[i].title == title) {
          return true;
        }
        if ("items" in items[i]) {
          for (var y = 0; y < items[i].items.length; y++) {
            if (items[i].items[y].title == title) {
              return true;
            }
          }
        }
      }
      return false;
    },
  },
  mounted() {
    this.localItems = _.clone(this.assetsOrScopes, true);
    console.log('mounted', this.localItems);
  },
};
</script>
<style>
.vue-recycle-scroller {
  position: relative;
}

.vue-recycle-scroller.direction-vertical:not(.page-mode) {
  overflow-y: auto;
}

.vue-recycle-scroller.direction-horizontal:not(.page-mode) {
  overflow-x: auto;
}

.vue-recycle-scroller.direction-horizontal {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.vue-recycle-scroller__slot {
  -webkit-box-flex: 1;
  -ms-flex: auto 0 0px;
  flex: auto 0 0;
}

.vue-recycle-scroller__item-wrapper {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}

.vue-recycle-scroller.ready .vue-recycle-scroller__item-view {
  position: absolute;
  top: 0;
  left: 0;
  will-change: transform;
}

.vue-recycle-scroller.direction-vertical .vue-recycle-scroller__item-wrapper {
  width: 100%;
}

.vue-recycle-scroller.direction-horizontal .vue-recycle-scroller__item-wrapper {
  height: 100%;
}

.vue-recycle-scroller.ready.direction-vertical .vue-recycle-scroller__item-view {
  width: 100%;
}

.vue-recycle-scroller.ready.direction-horizontal .vue-recycle-scroller__item-view {
  height: 100%;
}

.resize-observer[data-v-b329ee4c] {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  pointer-events: none;
  display: block;
  overflow: hidden;
  opacity: 0;
}

.resize-observer[data-v-b329ee4c] object {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}

.dynamic-scroller-demo,
.scroller {
  height: 100%;
}

.dynamic-scroller-demo {
  overflow: hidden;
}

.notice {
  padding: 24px;
  font-size: 20px;
  color: #999;
}

.message {
  display: flex;
  min-height: 32px;
  padding: 12px;
  box-sizing: border-box;
}

.avatar {
  flex: auto 0 0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 12px;
}

.avatar .image {
  max-width: 100%;
  max-height: 100%;
  border-radius: 50%;
}

.index,
.text {
  flex: 1;
}

.text {
  max-width: 400px;
}

.index {
  opacity: 0.5;
}

.index span {
  display: inline-block;
  width: 160px;
  text-align: right;
}

.scroller {
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/internal/AssetsTree.vue